var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShieldCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3346 21.6666C33.3346 29.9999 27.5013 34.1666 20.568 36.5833C20.2049 36.7063 19.8105 36.7004 19.4513 36.5666C12.5013 34.1666 6.66797 29.9999 6.66797 21.6666V9.99994C6.66797 9.55791 6.84356 9.13399 7.15612 8.82142C7.46869 8.50886 7.89261 8.33327 8.33464 8.33327C11.668 8.33327 15.8346 6.33327 18.7346 3.79994C19.0877 3.49827 19.5369 3.33252 20.0013 3.33252C20.4657 3.33252 20.9149 3.49827 21.268 3.79994C24.1846 6.34994 28.3346 8.33327 31.668 8.33327C32.11 8.33327 32.5339 8.50886 32.8465 8.82142C33.159 9.13399 33.3346 9.55791 33.3346 9.99994V21.6666Z",
    stroke: "#CCA466",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.0001L18.3333 23.3334L25 16.6667",
    stroke: "#CCA466",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldCheck);
export default __webpack_public_path__ + "static/media/iconShieldCheck.9c1be9f502c3907e90d6f2f8e86e66f8.svg";
export { ForwardRef as ReactComponent };